(function () {
    'use strict';

    angular.module("imApp").factory("textileModelCategory5LangService", ['$ihttp', function ($ihttp) {
        let service = {
            listTextileModelCategory5Languages: function (parms) {
                return $ihttp.post({
                    method: 2688,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2689,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
